import { useAtomValue, useSetAtom } from 'jotai';
import { reviewsDataAtom } from '../../atoms';

export const useSellerReviews = () => {
    const reviewsData = useAtomValue(reviewsDataAtom);
    return reviewsData;
};

export const useSellerReviewsUpdater = () => useSetAtom(reviewsDataAtom);
